import axios, { AxiosResponse } from 'axios';
import { IContract } from '../model/search.model';
import { IUserInfo } from '../model/userInfo.model';

export interface IContractApi {
  getSubscriptionByNumber(number: string, checkUserAttribute: string): Promise<AxiosResponse<any>>;
  getClaimsSubscriptionByNumber(subNumber: string): Promise<AxiosResponse<any>>;
  getSubscriptionByClient(client: IContract): Promise<AxiosResponse<any>>;
  getAllSubscriptionByClient(client: IContract): Promise<AxiosResponse<any>>;
  getActiveSubscriptionByClient(client: IContract): Promise<AxiosResponse<any>>;
  recoverAndActiveSubscriptionsClients(client: IContract): Promise<AxiosResponse<any>>;

}

export class ContractApi implements IContractApi {
  async getSubscriptionByNumber(subscriptionNumber: string, checkUserAttribute: string): Promise<AxiosResponse<any>> {
    return axios.get('api/contract/getSubscription/' + subscriptionNumber);
  }

  async getSubscriptionAndOffer(number: string): Promise<AxiosResponse<any>> {
    return axios.get('api/contract/getSubscriptionAndOffer', { params: { number } });
  }

  async getClaimsSubscriptionByNumber(number: string): Promise<AxiosResponse<any>> {
    return axios.get('api/contract/getSubscriptionClaims', { params: { subscriptionNumber: number } });
  }

  async getProductOffreByNumber(number: string): Promise<AxiosResponse<any>> {
    return axios.get('api/contract/getProductOffer', { params: { offerCode: number } });
  }

  async getAllSubscriptionByClient(client: IContract): Promise<AxiosResponse<any>> {
    return axios.post('api/contract/clients/subscriptions',client);
  }
  async getActiveSubscriptionByClient(): Promise<AxiosResponse<any>> {
    return axios.get('api/contract/clients/activeSubscriptions');
  }

  async getSubscriptionByClient(client: IContract): Promise<AxiosResponse<any>> {
    return axios.post('api/contract/clients/activeSubscriptions', client);
  }

  async updateUserInfo(actor: IUserInfo,number:string): Promise<AxiosResponse<any>> {
    return axios.post('api/subscriber/updateSubscriber',actor,{params :{number}});
  }
  async getListImpayeInfo(number: string): Promise<AxiosResponse<any>> {
    return axios.get(`api/contract/subscriptionsImpyesList/${number}`);
  }

  async getContractualDocument(offerCode: string): Promise<AxiosResponse<any>> {
    return axios.get(`api/document/getContractualDocument/${offerCode}`);
  }
  async recoverAndActiveSubscriptionsClients(): Promise<AxiosResponse<any>> {
    return axios.get('api/contract/clients/recoverAndActiveSubscriptionsClients');
  }
}
